import { Task, TaskUser } from '../types';

export const MOCK_USERS: TaskUser[] = [
  { id: 1, name: 'Shreyas Ananth', initials: 'SA', avatarColor: 'bg-purple-600' },
  { id: 2, name: 'Gouri M H', initials: 'GM', avatarColor: 'bg-blue-600' },
  { id: 3, name: 'Arjun Mehta', initials: 'AM', avatarColor: 'bg-emerald-600' },
  { id: 4, name: 'Priya Nair', initials: 'PN', avatarColor: 'bg-rose-600' },
  { id: 5, name: 'Rahul Sharma', initials: 'RS', avatarColor: 'bg-amber-600' },
];

const ceo = MOCK_USERS[0];
const gouri = MOCK_USERS[1];
const arjun = MOCK_USERS[2];
const priya = MOCK_USERS[3];
const rahul = MOCK_USERS[4];

export const MOCK_TASKS: Task[] = [
  {
    id: 'task-1',
    key: 'TB-1',
    title: 'Prepare June P&L report for board meeting',
    description:
      'Compile all city-level P&L data for June. Include location variance breakdown and YoY comparison. Share draft with CEO by Wednesday.',
    assignee: gouri,
    reporter: ceo,
    priority: 'urgent',
    status: 'in_progress',
    team: 'Finance',
    dueDate: '2026-06-12',
    labels: ['Finance', 'Board'],
    createdAt: '2026-06-07T09:00:00Z',
    updatedAt: '2026-06-08T10:30:00Z',
    statusHistory: [
      {
        from: 'todo',
        to: 'in_progress',
        changedBy: gouri,
        changedAt: '2026-06-08T10:30:00Z',
      },
    ],
    comments: [
      {
        id: 'c1',
        author: ceo,
        text: 'Make sure to include the Bengaluru location variance separately.',
        createdAt: '2026-06-07T09:15:00Z',
      },
    ],
  },
  {
    id: 'task-2',
    key: 'TB-2',
    title: 'Fix the Safari date picker bug in client billing',
    description:
      'The effective from month picker breaks on Safari. Dropdowns need to replace native date inputs for cross-browser compatibility.',
    assignee: gouri,
    reporter: arjun,
    priority: 'high',
    status: 'done',
    team: 'Engineering',
    dueDate: '2026-06-09',
    labels: ['Bug', 'Frontend'],
    createdAt: '2026-06-06T11:00:00Z',
    updatedAt: '2026-06-08T16:00:00Z',
    statusHistory: [
      {
        from: 'todo',
        to: 'in_progress',
        changedBy: gouri,
        changedAt: '2026-06-07T09:00:00Z',
      },
      {
        from: 'in_progress',
        to: 'done',
        changedBy: gouri,
        changedAt: '2026-06-08T16:00:00Z',
      },
    ],
    comments: [],
  },
  {
    id: 'task-3',
    key: 'TB-3',
    title: 'Onboard 3 new KAM clients in Hyderabad',
    description:
      'Coordinate with the Hyderabad ops team to complete KAM client onboarding. Ensure SKU mapping is done and billing setup is complete.',
    assignee: arjun,
    reporter: ceo,
    priority: 'high',
    status: 'todo',
    team: 'KAM',
    dueDate: '2026-06-15',
    labels: ['KAM', 'Ops'],
    createdAt: '2026-06-07T14:00:00Z',
    updatedAt: '2026-06-07T14:00:00Z',
    statusHistory: [],
    comments: [],
  },
  {
    id: 'task-4',
    key: 'TB-4',
    title: 'Review and approve vendor invoice for Mumbai warehouse',
    description:
      'Zoho AP queue has 4 pending vendor invoices from the Mumbai warehouse supplier. Review and approve before the 10th.',
    assignee: priya,
    reporter: ceo,
    priority: 'medium',
    status: 'todo',
    team: 'Finance',
    dueDate: '2026-06-10',
    labels: ['Finance', 'Approvals'],
    createdAt: '2026-06-08T08:00:00Z',
    updatedAt: '2026-06-08T08:00:00Z',
    statusHistory: [],
    comments: [],
  },
  {
    id: 'task-5',
    key: 'TB-5',
    title: 'Set up weekly ops review cadence with city leads',
    description:
      'Create a recurring calendar invite for Monday 10am ops review. Prepare the standard template for city leads to fill before each meeting.',
    assignee: rahul,
    reporter: ceo,
    priority: 'medium',
    status: 'backlog',
    team: 'Operations',
    dueDate: null,
    labels: ['Ops', 'Process'],
    createdAt: '2026-06-05T10:00:00Z',
    updatedAt: '2026-06-06T12:00:00Z',
    statusHistory: [
      {
        from: 'todo',
        to: 'backlog',
        changedBy: rahul,
        changedAt: '2026-06-06T12:00:00Z',
        reason:
          'City leads are travelling this week. Will pick this up after 12th June once everyone is back.',
      },
    ],
    comments: [],
  },
  {
    id: 'task-6',
    key: 'TB-6',
    title: 'Audit shift reporting data quality for May',
    description:
      'Several shift reports for May had missing QC rejection data. Audit all May reports and flag discrepancies to the ops leads.',
    assignee: arjun,
    reporter: arjun,
    priority: 'low',
    status: 'backlog',
    team: 'Operations',
    dueDate: null,
    labels: ['Ops', 'Reporting'],
    createdAt: '2026-06-04T09:00:00Z',
    updatedAt: '2026-06-05T11:00:00Z',
    statusHistory: [
      {
        from: 'todo',
        to: 'backlog',
        changedBy: arjun,
        changedAt: '2026-06-05T11:00:00Z',
        reason: 'Higher priority items came up. This is informational and can wait till end of June.',
      },
    ],
    comments: [],
  },
  {
    id: 'task-7',
    key: 'TB-7',
    title: 'Build transit plan summary export to Excel',
    description:
      'Transit plan listing page needs an Excel export button. Should export all visible rows with filters applied.',
    assignee: gouri,
    reporter: ceo,
    priority: 'medium',
    status: 'todo',
    team: 'Engineering',
    dueDate: '2026-06-20',
    labels: ['Frontend', 'Feature'],
    createdAt: '2026-06-08T09:00:00Z',
    updatedAt: '2026-06-08T09:00:00Z',
    statusHistory: [],
    comments: [
      {
        id: 'c2',
        author: ceo,
        text: 'This is needed before the investor demo on the 20th.',
        createdAt: '2026-06-08T09:05:00Z',
      },
    ],
  },
  {
    id: 'task-8',
    key: 'TB-8',
    title: 'Reconcile June payroll data with HR system',
    description:
      'Cross-check June payroll run against attendance records. Flag any mismatches to the HR head.',
    assignee: priya,
    reporter: priya,
    priority: 'high',
    status: 'in_progress',
    team: 'HR',
    dueDate: '2026-06-11',
    labels: ['HR', 'Payroll'],
    createdAt: '2026-06-08T07:30:00Z',
    updatedAt: '2026-06-09T08:00:00Z',
    statusHistory: [
      {
        from: 'todo',
        to: 'in_progress',
        changedBy: priya,
        changedAt: '2026-06-09T08:00:00Z',
      },
    ],
    comments: [],
  },
];
